import { ca } from '@cian/analytics';

import { TAction } from '../../types/customActions';
import { TOpenedChat } from '../../types/openedChats';
import { getCategory } from '../../utils/trackings_helpers';

function getProducts(chat: TOpenedChat | null, companionId?: number) {
  const { chatId, offer } = chat || {};

  if (!offer) {
    return [
      {
        extra: { chatId },
      },
    ];
  }

  const category = getCategory(offer);

  const [dealType, objectType] = category.split('/');

  return [
    {
      brand: '',
      category,
      cianId: offer.id,
      dealType,
      hiddenBase: false,
      id: offer.id,
      objectType,
      published: true,
      // Всегда передаем 1
      quantity: 1,
      variant: [],
      extra: { chatId, companionId },
    },
  ];
}

export function trackOpenUserCard(chat: TOpenedChat | null, companionId?: number, opponentId?: number) {
  try {
    ca('eventSite', {
      action: 'show_sopr',
      category: 'Chat',
      label: 'contact',
      name: 'oldevent',
      products: getProducts(chat, companionId),
      page: {
        extra: {
          opponent_id: opponentId,
        },
      },
    });
  } catch (error) {
    console.debug('trackOpenUserCard', error);
  }
}

export function trackUserProfileClick(chat: TOpenedChat | null, companionId?: number, opponentId?: number) {
  ca('eventSite', {
    action: 'moreMenu_about_user',
    category: 'Chat',
    name: 'oldevent',
    products: getProducts(chat, companionId),
    page: {
      extra: {
        opponent_id: opponentId,
      },
    },
  });
}

export function trackClickMoveToSpam(chat: TOpenedChat | null, companionId?: number, opponentId?: number) {
  ca('eventSite', {
    action: 'click_sopr',
    category: 'contact',
    label: 'block',
    name: 'oldevent',
    products: getProducts(chat, companionId),
    page: {
      extra: {
        opponent_id: opponentId,
      },
    },
  });
}
export function trackClickMoveToArchive(chat: TOpenedChat | null, companionId?: number, opponentId?: number) {
  ca('eventSite', {
    action: 'click_sopr',
    category: 'contact',
    label: 'archive',
    name: 'oldevent',
    products: getProducts(chat, companionId),
    page: {
      extra: {
        opponent_id: opponentId,
      },
    },
  });
}

export function trackClickCallButton(chat: TOpenedChat | null, companionId?: number, opponentId?: number) {
  ca('eventSite', {
    action: 'click_sopr',
    category: 'contact',
    label: 'copy_phone',
    name: 'oldevent',
    products: getProducts(chat, companionId),
    page: {
      extra: {
        opponent_id: opponentId,
      },
    },
  });
}

export function trackSuccessSendCustomAction(
  chat: TOpenedChat | null,
  customAction: TAction,
  companionId?: number,
  opponentId?: number,
) {
  ca('eventSite', {
    action: 'click_sopr',
    category: 'contact',
    label: customAction,
    name: 'oldevent',
    products: getProducts(chat, companionId),
    page: {
      extra: {
        opponent_id: opponentId,
        chatId: chat?.chatId,
      },
    },
  });
}
